import { Injectable } from "@angular/core";
import { CustomerClient, WebCustomer } from "../models";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class OldCustomerSearchService
{

  private customerListItemsSubject: BehaviorSubject<WebCustomer[]>;
  public customerList: Observable<WebCustomer[]>;

  constructor(
    private customerClient: CustomerClient
  )
  {
    this.customerListItemsSubject = new BehaviorSubject<WebCustomer[]>([]);
    this.customerList = this.customerListItemsSubject.asObservable();
  }

  public clear()
  {
    this.customerListItemsSubject.next([]);
  }

  public getCustomerListItems(searchText: string)
  {
    this.customerClient.getWebCustomerListItems(searchText)
      .subscribe(items => this.customerListItemsSubject.next(items));
  }

}
